import { tv, type VariantProps } from 'tailwind-variants'

export const text = tv({
  variants: {
    font: {
      beausite: 'font-beausite',
      nbArchitekt: 'font-nb-architekt',
    },
    size: {
      16: 'text-base leading-[1.4]',
      14: 'text-sm leading-[1.4]',
      12: 'text-xs leading-[1.4]',
      10: 'text-[0.625rem] leading-[1.4]',
    },
    color: {
      white: 'text-white',
      gold: 'text-gold',
      cream: 'text-cream',
      orange: 'text-orange',
      brown: 'text-brown',
    },
    weight: {
      light: 'font-light',
      regular: 'font-normal',
      bold: 'font-bold',
    },
    block: {
      true: 'block',
    },
  },
  defaultVariants: {
    font: 'beausite',
    size: 16,
    color: 'white',
  },
  // Letter spacing follows the Figma style guide: NB Architekt is 6% at 10-12px (P X-Small) and
  // 4% at 14px and up (H4).
  compoundVariants: [
    {
      font: 'nbArchitekt',
      size: 10,
      // When using NB Architekt with size 10, use the following line-height and letter-spacing
      className: 'leading-[1.2] tracking-[0.06em]',
    },
    {
      font: 'nbArchitekt',
      size: 12,
      // When using NB Architekt with size 12, use the following line-height and letter-spacing
      className: 'leading-[1.2] tracking-[0.06em]',
    },
    {
      font: 'nbArchitekt',
      size: [14, 16],
      className: 'tracking-[0.04em]',
    },
  ],
})

export type Variants = VariantProps<typeof text>
